import { t } from '@framework/i18n/intl/i18next.ts';
import { yup } from '@framework/validation/initYup.ts';
import { RuleType } from '../../IRule.ts';
import { type IRuleType } from '../../IRuleType.ts';
import { TotalDigitsRuleComponent } from './TotalDigitsRuleComponent.tsx';

const configValidator = yup
  .object({
    value: yup
      .number()
      .notRequired()
      .positive()
      .integer()
      .label('Numero massimo di cifre'),
    customMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown();

type IRuleTotalDigitsType = yup.InferType<typeof configValidator>;

export const TotalDigitsRule: IRuleType<IRuleTotalDigitsType> = {
  type: RuleType.TotalDigits,
  name: 'Numero massimo di cifre',
  configComponent: TotalDigitsRuleComponent,
  configValidator,
  validator: (schema, rule) => {
    if (!rule?.value) return schema;

    const max = rule.value;

    return (schema as yup.NumberSchema).test({
      name: 'total-digits',
      params: { max },
      skipAbsent: true,
      message:
        rule.customMessage ??
        t(
          'rules.total-digits.max',
          'Il campo ${label} non può avere più di {{max}} cifre',
          { max },
        ),
      test(value) {
        if (value == null) return true;
        const digits = String(Math.abs(value)).replace('.', '').length;
        return digits <= max;
      },
    });
  },
};
